import {useTranslation} from "react-i18next";
import moment from "moment";
import {FormProvider, useForm} from 'react-hook-form'
import {useDispatch} from "react-redux";

import cx from 'classnames';

import Button from "@mui/material/Button";
import { Search as SearchIcon } from '@vedmarket/ui-kit';

import { readOnlyButtonEndIcon } from 'components/common/read-only-action-icon';
import 'components/common/read-only-action-button.scss';
import Typography from "@mui/material/Typography";

import { getFlag } from "./helpers";
import SearchForm from './components/searchForm'
import { Completed } from '@vedmarket/ui-kit';
import MenuButton from '../../../../common/menuButton';
import React, { useState, useEffect } from "react";
import ModalBig from "../../../../common/modalBig";
import ModalSearch from './components/modalSearch'
import DeliveryCard from './components/card';
import {
  useAddServicesToRouteByOrderIdMutation,
  useGetRoutesMutation,
  useGetAdditionalServicesByOrderIdQuery,
  useGetRouteByOrderIdQuery,
  useLazyDeclarationsByOrderIdQuery,
  useLazyDeclarationSummaryByOrderIdQuery,
  useLazyGetBankCommissionsByOrderIdQuery,
  useLazyGetBrokerDataByCodeQuery,
  useLazyGetOrderSummaryByIdQuery,
  useLazyGetOrderSummaryInvoicesByIdQuery,
  useSetCompletedByOrderIdMutation,
  useSummary,
  useSummaryCompleted,
  useSummaryOrder,
  useUpdateBankCommissionsByInvoiceId, useLazyInvoicesByOrderIdQuery, useParamsData
} from "../../../../../api/calc";
import {useGetCalcIdFromRoute} from "../../../../../utils/hooks";
import {useDemoDelivery} from 'components/cabinet/demo/steps/delivery/use-delivery';

import {useLazyGetLocationsQuery} from "../../../../../api/locations";
import {COLORS} from "../../../../../config/constants";
import {isCalculationViewModeError} from 'utils/helpers';

import {useCalculationReadOnly} from '../../calculation-read-only';

import './delivery.scss';
import STYLE_COLORS from 'styles/colors.scss';

export enum DELIVERY_FORM {
  LOCATION_FROM = 'location_from',
  LOCATION_TO = 'location_to',
  CITY_NAME_FROM = 'city_name_from',
  CITY_NAME_TO = 'city_name_to',
  PLANNED_SHIPMENT_DATE = 'planned_shipment_date',
}

export type DeliveryFormFields = {
  [DELIVERY_FORM.LOCATION_FROM]: string
  [DELIVERY_FORM.LOCATION_TO]: string
  [DELIVERY_FORM.PLANNED_SHIPMENT_DATE]: string
  [DELIVERY_FORM.CITY_NAME_FROM]?: string
  [DELIVERY_FORM.CITY_NAME_TO]?: string
}
type Props = {
  handleChoose(): void
}

const Delivery = ({handleChoose}: Props) => {

  const [ shouldOpenModal, setShouldOpenModal ] = useState(false)

  const [ routes, setRoutes ] = React.useState();

  const orderId = useGetCalcIdFromRoute()

  const currentDeliveryType = useSummary()?.delivery_type;

  const summaryOrder = useSummaryOrder();
  const dispatch = useDispatch()

  const [ locationsRequest ] = useLazyGetLocationsQuery()
  const [ triggerFetchSummaryDeclaration ] = useLazyDeclarationSummaryByOrderIdQuery();
  const [ triggerFetchBankCommissionsRequest ] = useLazyGetBankCommissionsByOrderIdQuery()
  const [ triggerFetchOrderSummaryRequest ] = useLazyGetOrderSummaryByIdQuery()
  const [ triggerGetBrokerDataByCode ] = useLazyGetBrokerDataByCodeQuery();
  const [ triggerFetchDeclaration ] = useLazyDeclarationsByOrderIdQuery();
  const [ triggerOrderSummary ] = useLazyGetOrderSummaryInvoicesByIdQuery();
  const [ triggerSummaryDeclaration ] = useLazyDeclarationSummaryByOrderIdQuery();
  const [ setCompleted ] = useSetCompletedByOrderIdMutation()
  const [ addServices ] = useAddServicesToRouteByOrderIdMutation()
  const [ triggerGetInvoices ] = useLazyInvoicesByOrderIdQuery();

  const deliveryIsCompleted = useSummaryCompleted()?.delivery

  const { data: routeInfo, refetch: refetchRoutes } = useGetRouteByOrderIdQuery(orderId, { skip: !orderId })
  const { refetch: refetchAddServices } = useGetAdditionalServicesByOrderIdQuery(orderId, { skip: !orderId })

  useEffect(() => {
  }, [ currentDeliveryType, summaryOrder?.delivery_type ])

  const filterData = useParamsData();

  const { t } = useTranslation()

  const readOnly = useCalculationReadOnly()

  const demoPlayback = useDemoDelivery(routeInfo, deliveryIsCompleted, {
    [DELIVERY_FORM.LOCATION_FROM]: filterData?.[DELIVERY_FORM.LOCATION_FROM],
    [DELIVERY_FORM.LOCATION_TO]: filterData?.[DELIVERY_FORM.LOCATION_TO],
    [DELIVERY_FORM.PLANNED_SHIPMENT_DATE]: filterData?.[DELIVERY_FORM.PLANNED_SHIPMENT_DATE],
  })

  const methods = useForm<DeliveryFormFields>({
    defaultValues: demoPlayback.formValues,
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const [ getRoutes ] = useGetRoutesMutation()

  if (!orderId) {
    return null;
  }

  const handleSend = (data: DeliveryRouteParamsMain) => {
    getRoutes({orderId, ...data}).then((data) => {
      // @ts-ignore
      setRoutes(data?.data)
    });
    setShouldOpenModal(true);
  }

  const getCompletedInfo = () => {
    return [
      {
        label: <span className='delivery-property'>
          <Typography component='span' className='delivery-property__point' sx={{
            fontSize: '14px',
            lineHeight: '18px',
            color: COLORS.BLACK_DARK,
          }}>A</Typography>
          {t('common__text__fromCity')}
        </span>,
        value: <span className='delivery-info'>
          {getFlag({code: routeInfo?.location_from.country.code, width: '20px', marginRight: '8px' })}
          {`${routeInfo?.location_from?.name} ${routeInfo?.location_from?.type !== 'city' && routeInfo?.location_from?.type !== 'CITY' ? routeInfo?.location_from?.type.toUpperCase() : ''} (${routeInfo?.location_from?.country.name})`}</span>
      },
      {
        label: <span className='delivery-property'>
          <Typography component='span' className='delivery-property__point' sx={{
            fontSize: '14px',
            lineHeight: '18px',
            color: COLORS.BLACK_DARK,
          }}>B</Typography>
          {t('common__text__toCity')}
        </span>,
        value: <span className='delivery-info'>
          {getFlag({code: routeInfo?.location_to?.country.code, width: '20px', marginRight: '8px' })}
          {`${routeInfo?.location_to?.name} ${routeInfo?.location_to?.type !== 'city' && routeInfo?.location_to?.type !== 'CITY' ? routeInfo?.location_to?.type.toUpperCase() : ''} (${routeInfo?.location_to?.country.name})`}</span>
      },
      {
        label: t('calc__text__delivery__plannedShipmentDate'),
        value: moment(routeInfo?.planned_shipment_date).format('DD.MM.YYYY'),
      }
    ]
  }

  const refetchRequests = async () => {
    await refetchRoutes()
    await triggerFetchSummaryDeclaration(orderId);
    await triggerFetchDeclaration(orderId);
    await triggerSummaryDeclaration(orderId)
    await triggerOrderSummary(orderId);
    await triggerFetchOrderSummaryRequest(orderId);
    await triggerGetBrokerDataByCode(orderId);
    await triggerGetInvoices(orderId);
    await triggerFetchBankCommissionsRequest({orderId}).then(data => {
      const bankCommissionInvoices = data?.data?.invoices;
      bankCommissionInvoices?.map((bankCommissionInvoice) => {

        const bankingCommissions = bankCommissionInvoice.banking_commissions;

        bankingCommissions.forEach((bankingCommission) => {
          const dataToSend = {
            orderId,
            invoiceNumber: bankCommissionInvoice.invoice_num,
            // id: bankingCommission.id,
            isRemove: true,
            data: {
              id: bankingCommission.id,
            }
          }

          // @ts-ignore
          dispatch(useUpdateBankCommissionsByInvoiceId(dataToSend));
        })
      })
    });
    await refetchAddServices()
    await setCompleted({
      orderId,
      delivery: true,
      customs: false,
      certification: false,
      banking_commissions: false,
      additional_services: false
    })
    demoPlayback.complete()
    handleChoose();
  }

  const handleEdit = async () => {

    if (!routeInfo) {
      return;
    }

    let cityFromId = routeInfo.location_from.id;
    let cityToId = routeInfo.location_to.id;


    await locationsRequest({ id: routeInfo?.location_from?.id}).then((response) => {
      cityFromId = response?.data?.find(item => item.code === routeInfo?.location_from?.code)?.id || cityFromId
    })

    await locationsRequest({ id: routeInfo?.location_to?.id}).then((response) => {
      cityToId = response?.data?.find(item => item.code === routeInfo?.location_to?.code)?.id || cityToId
    })

    const plannedShipmentDate = moment(routeInfo?.planned_shipment_date).format('YYYY-MM-DD')
    const resetFiltersParams = {
      shipping_method: undefined,
      shipping_time: '',
      price_total_min: undefined,
      price_total_max: undefined,
      delivery_date_from: undefined,
      delivery_date_to: undefined,
      page: 1,
      order_by: undefined,
    }

    const routeSearchParams: DeliveryRouteParamsInput = {
      orderId,
      [DELIVERY_FORM.LOCATION_FROM]: cityFromId,
      [DELIVERY_FORM.LOCATION_TO]: cityToId,
      [DELIVERY_FORM.CITY_NAME_FROM]: routeInfo?.location_from.name,
      [DELIVERY_FORM.CITY_NAME_TO]: routeInfo?.location_to.name,
      [DELIVERY_FORM.PLANNED_SHIPMENT_DATE]: plannedShipmentDate,
      ...resetFiltersParams,
    }

    methods.reset({
      [DELIVERY_FORM.LOCATION_FROM]: cityFromId,
      [DELIVERY_FORM.LOCATION_TO]: cityToId,
      [DELIVERY_FORM.PLANNED_SHIPMENT_DATE]: plannedShipmentDate,
    })

    await getRoutes(routeSearchParams).then((data) => {
      // @ts-ignore
      setRoutes(data?.data)
      setShouldOpenModal(true)
    });

  }

  const handleClose = () => setShouldOpenModal(false);

  const handleRemove = async () => {
    const result = await addServices({
      orderId,
      route: null,
      services: []
    });

    if (isCalculationViewModeError(result)) {
      return;
    }

    await setCompleted({
      orderId,
      delivery: false,
      customs: false,
      certification: false,
      banking_commissions: false,
      additional_services: false
    })

    await refetchRoutes()
    await refetchAddServices()
  }

  return (
    <FormProvider {...methods}>
      {demoPlayback.shouldShowCompleted ?
        <Completed
          info={getCompletedInfo()}
          isFullRow
          onEdit={handleEdit}
          MenuComponent={MenuButton}
          onRemove={handleRemove}
          caption={t('calc__text__delivery__chooseRoute')}
        />
        : <SearchForm
          demoRoute={demoPlayback.demoRoute}
          onSend={handleSend}
        />}
      {demoPlayback.shouldShowCompleted && <div {...demoPlayback.choiceProps}>
        <Typography
          variant='subtitle1'
          sx={{ marginBottom: 3, marginTop: 3, fontWeight: 500, lineHeight: '24px', color: COLORS.BLACK_DARK }}
        >
          {t('calc__text__delivery__yourChoice')}
        </Typography>
        <DeliveryCard
          isActive
          route={routeInfo}
          refetch={refetchRequests}
          handleRemove={handleRemove}
          isChosen
        />
        <Button
          {...demoPlayback.findButtonProps}
          variant='outlined'
          className={cx({ 'read-only-action-button': readOnly })}
          disabled={readOnly}
          startIcon={<SearchIcon />}
          endIcon={readOnlyButtonEndIcon(readOnly)}
          fullWidth
          sx={{
            'svg:nth-of-type(1)': { fontSize: '24px' }
          }}
          onClick={readOnly ? undefined : handleEdit}
          title={readOnly ? t('calc__message__lockedByApplication') : undefined}
        ><Typography component='span' variant='button'>{t('actions__text__findOtherDeliveryOptions')}</Typography></Button>
      </div>
      }
      <ModalBig
        isOpen={Boolean(shouldOpenModal && routes)}
        onClose={handleClose}
        title={t('actions__text__searchDeliveryOptions')}
        isSearch
        width={1120}
        customStyles={{
          background: STYLE_COLORS.BLUE_GRAY,
          marginTop: '80px',
          marginBottom: '80px',
          verticalAlign: 'top',
        }}
      >
        <ModalSearch
          preloadRoutes={routes}
          refetch={refetchRequests}
          handleRemove={handleRemove}
          handleClose={handleClose}
        />
      </ModalBig>
    </FormProvider>
  )
}

export default Delivery
